module.exports = require("@mui/icons-material/FormatAlignLeft");